import { Tooltip as RechartTooltip } from "recharts";
import _ from "lodash";

const isNumber = (value) => _.isNumber(value) && !_.isNaN(value);

export class Tooltip extends RechartTooltip {
  currentBarHeight = () => {
    const { chartData, payload, viewBox } = this.props;
    let maxValue = 0;
    let currentValue = 0;
    const keys = [];
    if (payload) {
      for (const p of payload) {
        if (p.value) {
          currentValue += p.value;
        }
        keys.push(p.dataKey);
      }
    }
    for (const p of chartData) {
      let s = 0;
      for (const key of keys) {
        if (p[key]) {
          s += p[key];
        }
      }
      if (s > maxValue) maxValue = s;
    }
    return (viewBox.height * currentValue) / maxValue;
  };

  getTranslate = ({ key, tooltipDimension, viewBoxDimension }) => {
    const { coordinate, position, viewBox } = this.props;

    if (position && isNumber(position[key])) {
      return position[key];
    }
    if (key === "y") {
      return (
        viewBoxDimension -
        this.currentBarHeight() -
        tooltipDimension +
        viewBox.top
      );
    }
    return coordinate[key] - tooltipDimension / 2;
  };
}
